const fullVariantSizeText = (variantPackageDisplayUnit: string) => {
  if (/oz$/.test(variantPackageDisplayUnit)) {
    return variantPackageDisplayUnit.replace(/oz$/, "ounce");
  } else if (/[^m]g$/.test(variantPackageDisplayUnit)) {
    const packageUnitMatch = variantPackageDisplayUnit.match(/^\d+/);
    const unitSize = Number((packageUnitMatch && packageUnitMatch[0]) || 1);
    const unitCopy = unitSize === 1 ? "gram" : "grams";
    return variantPackageDisplayUnit.replace(/g$/, unitCopy);
  } else if (/pc$/.test(variantPackageDisplayUnit)) {
    return variantPackageDisplayUnit.replace(/pc$/, "each");
  } else {
    return variantPackageDisplayUnit;
  }
};

export default fullVariantSizeText;
